import { render, staticRenderFns } from "./ThreeStep.vue?vue&type=template&id=452c4492"
import script from "./ThreeStep.vue?vue&type=script&lang=js"
export * from "./ThreeStep.vue?vue&type=script&lang=js"
import style0 from "./ThreeStep.vue?vue&type=style&index=0&id=452c4492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports